/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto_Wealthlane_AwardSettlementService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto_Wealthlane_AwardSettlementService_Application_Contracts';
import type { Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsFillResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsFillResponseDto';
import type { Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_FillTradeOrderDto } from '../models/Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_FillTradeOrderDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CsBrokerTradeToolSettlementService {

    /**
     * @param transactionId 
     * @param companyId 
     * @param bookingType 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppCsBrokerTradeToolSettlementCreateOrder(
transactionId: string,
companyId?: string,
bookingType?: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/cs/broker-trade-tool/settlement/create-order/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            query: {
                'companyId': companyId,
                'bookingType': bookingType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tradeOrderId 
     * @param companyId 
     * @param requestBody 
     * @returns Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsFillResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardSettlementApiAppCsBrokerTradeToolSettlementFill(
tradeOrderId: string,
companyId?: string,
requestBody?: Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_FillTradeOrderDto,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsFillResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award-settlement/api/app/cs/broker-trade-tool/settlement/fill/{tradeOrderId}',
            path: {
                'tradeOrderId': tradeOrderId,
            },
            query: {
                'companyId': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @param companyId 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto_Wealthlane_AwardSettlementService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppCsBrokerTradeToolSettlementHistory(
participantId: string,
companyId?: string,
sorting?: string,
skipCount?: number,
maxResultCount: number = 10,
bookingType?: string,
status?: string,
recordType?: string,
dateFrom?: string,
dateTo?: string,
): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto_Wealthlane_AwardSettlementService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/cs/broker-trade-tool/settlement/history/{participantId}',
            path: {
                'participantId': participantId,
            },
            query: {
                'companyId': companyId,
                'sorting': sorting,
                'skipCount': skipCount,
                'maxResultCount': maxResultCount,
                'bookingType': bookingType,
                'status': status,
                'recordType': recordType,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param tradeOrderId 
     * @param companyId 
     * @param requestBody 
     * @returns void
     * @throws ApiError
     */
    public static putApiAwardSettlementApiAppCsBrokerTradeToolSettlementCancel(
tradeOrderId: string,
companyId?: string,
requestBody?: { voidReason: string },
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award-settlement/api/app/cs/broker-trade-tool/settlement/void/{tradeOrderId}',
            path: {
                'tradeOrderId': tradeOrderId,
            },
            query: {
                'companyId': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}

export type FillTradeOrderDto = Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_FillTradeOrderDto;
export type CsFillResponseDto = Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsFillResponseDto;
export type CsTransactionHistoryPagedDto = Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto_Wealthlane_AwardSettlementService_Application_Contracts;

export interface CsTransactionHistoryDto {
    tradeOrderId?: string;
    transactionId?: string;
    transactionDate?: string;
    shares?: number;
    status?: string;
    orderExecutionDate?: string;
    bookingType?: string;
    cancelStatus?: string;
    cancelRequestedDate?: string;
    action?: string;
    recordType?: string;
    recordTypeSystem?: string;
    enteredBy?: string;
    reasonCode?: string;
    creationTime?: string;
    orderNumber?: string;
    reconciliationStatus?: string;
    concurrencyStamp?: string;
}
